<app-modal-dialog 
[show]="showModal" 
size="lg" 
position="top"
(closed)="closedCreateNote()"
#modal >
    <div class="modal-header" modal-header>
        <h1>Crea una Boleta de Báscula</h1>
        <h1 style="left: 0" class="i-hover">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h1>
    </div>
    <div class="modal-body" modal-body>
        <div class="row mb-4">
            <div class="col-sm-6 form-group mb-4">
                <label for="provider-note" class="form-label">Proveedor<span
                    class="required">*</span></label>
                <div class="input-group">
                    <app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.provider"
                        [placeholder]="'Ingresa un Proveedor'" [filterElements]="filterProviders"
                        [typeElements]="'provider-note'" (inputMethod)="writeProvider($event.event)"
                        (changeStatus)="checkProvider($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                        ></app-input-autocomplete>
                </div>
            </div>
            <div class="col-sm-6 form-group mb-4">
                <label for="product-order" class="form-label">Producto</label>
                <div class="input-group">
                    <app-input-autocomplete
                        [allBorderRadius]="true"
                        [inputs]="inputs.product"
                        [placeholder]="'Ingresa un producto'"
                        [filterElements]="filterProducts"
                        [typeElements]="'product-order'"
                        (inputMethod)="writeProduct($event.event)"
                        (changeStatus)="checkProduct($event.filterElement)"
                        (getTitle)="
                            $event.filterElement.title =
                                $event.filterElement.code +
                                ' - ' +
                                $event.filterElement.name
                        "
                    ></app-input-autocomplete>
                </div>
            </div>

            <div class="col-sm-6 form-group">
                <label for="pilotName" class="form-label">Nombre del piloto</label>
                <input
                type="text"
                [(ngModel)]="scaleNoteData.pilot"
                name="pilotName"
                id="pilotName"
                class="form-control"
                placeholder="Ej: Juan Pérez"
                />
            </div>

            <div class="col-sm-6 form-group">
                <label for="pilotName" class="form-label">ID del Equipo</label>
                <input
                type="text"
                [(ngModel)]="scaleNoteData.equipmentId"
                name="pilotName"
                id="pilotName"
                class="form-control"
                placeholder="Ej: ANV461ABC - TAD454BBD"
                />
            </div>
            <div class="col-sm-12 d-flex flex-row justify-content-end gap-2 mt-4">
                <ng-container *ngFor="let item of scales">
                    <button class="btn btn-sm btn-secondary" (click)="setWeightSelected(item.id)"
                        [disabled]="loadingScales || scaleDetails.length==0">
                        <ng-container *ngIf="!loadingScales">
                            <i class="fa fa-scale-balanced"></i>
                        </ng-container>
                        <ng-container *ngIf="loadingScales">
                            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                            <span role="status"></span>
                        </ng-container> {{item.name}}
                    </button>
                </ng-container>
            </div>

        </div>
        <div class="row mb-4">
            <div class="row" *ngIf="scaleDetails.length > 0">
                <div class="col-12">
                    <div class="table-responsive table-bordered">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>Peso</th>
                                    <th class="td-center">Medida</th>
                                    <th class="td-center">B/T/N</th>
                                    <th class="td-center">Fecha</th>
                                    <th class="td-center">Hora</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor=" let item of scaleDetails; let i = index">
                                    <td>
                                        <input
                                            type="number"
                                            name="weight{{i}}"
                                            id="weight{{i}}"
                                            [(ngModel)]="item.weight"
                                            class="form-control"
                                            (focus)="selectedWeightIndex = i"
                                            [class.selected-input]="selectedWeightIndex === i"
                                        />
                                    </td>
                                    <td class="td-center">
                                        <span *ngIf="measurements">{{measurements.unit}}</span>
                                    </td>
                                    <td class="td-center">
                                        <span *ngIf="item.typeId==btnDetails[0].id">{{btnDetails[0].name}}</span>
                                        <span *ngIf="item.typeId==btnDetails[1].id">{{btnDetails[1].name}}</span>
                                        <span *ngIf="item.typeId==btnDetails[2].id">{{btnDetails[2].name}}</span>
                                    </td>
                                    <td class="text-right">
                                        <input
                                            type="date"
                                            name="date"
                                            id="date"
                                            [ngModel]="item.date | date: 'yyyy-MM-dd'"
                                            (ngModelChange)="item.date = $event"
                                            class="form-control"
                                        />
                                    </td>
                                    <td class="text-right">
                                        <input
                                            type="time"
                                            name="time"
                                            id="time"
                                            [ngModel]="item.time | date: 'HH:mm:ss'"
                                            (ngModelChange)="item.time = $event"
                                            class="form-control"
                                        />
                                    </td>
                                    <!-- <td class="td-center">
                                        <span class="text-danger a-hover" 
                                        tooltip="Eliminar"
                                        (click)="removeProduct(i)">
                                            <i class="fa fa-trash"></i>
                                        </span>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="d-flex justify-center">
                <button class="btn btn-success" (click)="createNote()"
                    [disabled]="loading || !inputs.provider.verified || !inputs.product.verified || scaleDetails.length == 0 || !verifyCreateNoteData()">
                    <ng-container *ngIf="!loading">
                        <i class="fa fa-floppy-disk"></i>
                    </ng-container>
                    <ng-container *ngIf="loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        <span role="status"></span>
                    </ng-container>GUARDAR
                </button>
            </div>
	    </div>
    </div>

</app-modal-dialog>